import React from 'react';

// TODO get from somewhere logical
const language = 'nl';

export default ({ index, object }) => <>{object[language][index]}</>;
